import { importCrmsAttachmentApi } from '@core/core/api'
import type { CrmsAttachment, SegySetupType } from '@core/core/types'
import { defaultUploadedFileStepStatuses } from '@core/core/types'
import type { ProjectId } from 'common/types'

import type { AppDispatch } from '../../store'
import { addMultipartFiles } from './common'

export const addRemoteCrmsFiles =
  (projectId: ProjectId, files: CrmsAttachment[]) => async (dispatch: AppDispatch) => {
    const attachments = files.filter(file => file.type === 'file')
    dispatch(
      addMultipartFiles(
        attachments.map(file => {
          const setupContent: SegySetupType = {
            surveyName: file.contentFileName,
            surveyType: 'Survey3D',
            domainType: 'TWT',
            ignoreSegy: false,
            check: false,
            ignoreZeros: true,
          }
          return {
            projectId,
            fileId: file.id,
            name: file.contentFileName,
            uploadId: file.id,
            progress: 0,
            fileSize: file.contentSize ?? 0,
            fileChunk: 0,
            step: 'conversion',
            statuses: {
              ...defaultUploadedFileStepStatuses,
              setup: 'succeeded',
              loading: 'succeeded',
              conversion: 'inprogress',
              ready: 'notstarted',
            },
            setupContent,
            initialSetupContent: setupContent,
            date: Date.now(),
            origin: 'crms',
            entityType: 'segy',
          }
        }),
      ),
    )

    for (const attachment of attachments) {
      await importCrmsAttachmentApi(projectId, attachment)
    }
  }
